import React from "react";
import Banner from "../components/marketplace/Banner";
import GigCategorySlider from "../components/marketplace/GigCategorySlider";
import CommonContainer from "../components/shared/CommonContainer";

export default function MarketplacePage() {
  return (
    <CommonContainer>
      <Banner />
      <GigCategorySlider title="Graphics &amp; Design" data={graphicsData} />
      <GigCategorySlider title="Web &amp; App Design" data={webData} />
      <GigCategorySlider title="Art &amp; Illustration" data={artData} />
      <GigCategorySlider title="Marketing Design" data={marketingData} />
    </CommonContainer>
  );
}

const graphicsData = [
  {
    label: "Logo Design",
    imageUrl: "/images/marketplace/graphics/logo.png",
  },
  {
    label: "Typography",
    imageUrl: "/images/marketplace/graphics/typography.png",
  },
  {
    label: "Stationery Design",
    imageUrl: "/images/marketplace/graphics/stationery.png",
  },
  {
    label: "Brochure Design",
    imageUrl: "/images/marketplace/graphics/brochure.png",
  },
  {
    label: "Brand Style Guides",
    imageUrl: "/images/marketplace/graphics/brand-style.png",
  },
];
const webData = [
  {
    label: "Website Design",
    imageUrl: "/images/marketplace/web/website.png",
  },
  {
    label: "App Design",
    imageUrl: "/images/marketplace/web/app.png",
  },
  {
    label: "UI Design",
    imageUrl: "/images/marketplace/web/ui.png",
  },
  {
    label: "Langing Page",
    imageUrl: "/images/marketplace/web/landing.png",
  },
  {
    label: "Icon Design",
    imageUrl: "/images/marketplace/web/icon.png",
  },
];
const artData = [
  {
    label: "Illustration",
    imageUrl: "/images/marketplace/art/illustration.png",
  },
  {
    label: "NFT Art",
    imageUrl: "/images/marketplace/art/nft.png",
  },
  {
    label: "Patern Design",
    imageUrl: "/images/marketplace/art/pattern.png",
  },
  {
    label: "Caricature",
    imageUrl: "/images/marketplace/art/caricature.png",
  },
  {
    label: "Story Boards",
    imageUrl: "/images/marketplace/art/story.png",
  },
];

const marketingData = [
  {
    label: "Social Media Post",
    imageUrl: "/images/marketplace/marketing/social.png",
  },
  {
    label: "Story Design",
    imageUrl: "/images/marketplace/marketing/story.png",
  },
  {
    label: "Email Design",
    imageUrl: "/images/marketplace/marketing/email.png",
  },
  {
    label: "Web Banners",
    imageUrl: "/images/marketplace/marketing/web.png",
  },
  {
    label: "Signage Design",
    imageUrl: "/images/marketplace/marketing/signage.png",
  },
];
